import { useGetHttp } from "../../http.hook";
import type { IProposalSocials } from "./add-proposal-social.admin.http";

interface IResponse {
  campaignProposalSocials: Array<IProposalSocials>;
}

export function useGetProposalSocialsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/proposals/:proposalId/socials",
  });
}
